var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAccountRadius13(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 37,
    height: 36,
    viewBox: "0 0 37 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.308594,
    width: 36,
    height: 36,
    rx: 13,
    fill: "#9983FC"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.4551 20.1156C21.4008 20.1156 23.8867 20.5865 23.8867 22.3998C23.8864 24.2134 21.3843 24.6664 18.4551 24.6664C15.5099 24.6664 13.0234 24.1965 13.0234 22.3832C13.0236 20.5693 15.5257 20.1156 18.4551 20.1156ZM18.4541 11.3334C20.4496 11.3335 22.0488 12.9028 22.0488 14.8607C22.0488 16.8187 20.4496 18.3889 18.4541 18.389C16.4592 18.389 14.8594 16.8187 14.8594 14.8607C14.8594 12.9027 16.4592 11.3334 18.4541 11.3334Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAccountRadius13);
export default __webpack_public_path__ + "static/media/account-radius-13.66fb78c87cdc62d4c63eaeb51fe615e7.svg";
export { ForwardRef as ReactComponent };